import { TaxonomyFormPage } from '../taxonomy/TaxonomyFormPage.js';

export function CarCategoryFormPage() {
  return (
    <TaxonomyFormPage
      config={{
        title: 'Category',
        apiPath: '/car-categories',
        basePath: '/car-categories',
        resource: 'carCategory',
        fields: [
          { name: 'description', label: 'Description', type: 'textarea' },
          { name: 'sort_order', label: 'Sort order', type: 'number', hint: 'Lower shows first' },
        ],
      }}
    />
  );
}
